import React, { useEffect, useRef, useState } from "react";
import AppTextField from "../../components/text-field/component";
import AppButton from "../../components/button/component";
import Loader from "../../components/loader";
import moment from "moment";
import CancelPlanPopup from "../../components/cancel-plan-popup/component";
import { toast } from "react-toastify";
import { getCookie } from "../../utils/utility-functions";
import { useNavigate } from "react-router-dom";
import { ROUTE_CONSTANT } from "../../routing/route-constants";
import FunnelStepTypes from "../funnel-step/types";
import { useDispatch } from "react-redux";
import ArrowIcon from "../../assets/settings/arrow-icon.svg";

const PushUserGuidSearchByAdmin = (userGUID) => {
  return {
    type: FunnelStepTypes.SET_USER_GUID_BY_ADMIN_USER,
    userGUID,
  };
};

function AdminUserDetails({
  searchUserConnect,
  getOrderDataByUserIdConnect,
  GetBillingConnect,
  AccountCancellationConnect,
  sendRefundRequestConnect,
  funnelStep,
}) {
  const { isAuth } = funnelStep;
  const [isOpen, setIsOpen] = useState(false);
  const [isSearchOpen, setIsSearchOpen] = useState(false);
  const [transactionDetails, setTransactionDetail] = useState(null);
  const [userData, setUserData] = useState(null);
  const [billingDetails, setBillingDetails] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [userNotExist, setUserNotExist] = useState("");
  const [billingNotExist, setBillingNotExist] = useState("");
  const [cancelReasonError, setCancelResonError] = useState(false);
  const [skuId, setSkuId] = useState("");
  const [isOpenCancellation, setIsOpenCancellation] = useState(false);
  const [formData, setFormData] = useState({
    email: "",
    accountNumer: "",
    userId: "",
  });
  // const token = getCookie("jwtToken");
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const CANCELLED_USER =
    billingDetails?.isScheduleCancel &&
    billingDetails?.isScheduleCancel === true;

  const [selectedCancelReason, setSelectedCancelReason] = useState();
  const [searchType, setSearchType] = useState();
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevFormData) => ({ ...prevFormData, [name]: value }));
  };
  useEffect(() => {
    if (!isAuth) {
      navigate(ROUTE_CONSTANT.ADMIN_LOGIN);
    }
  }, [isAuth]);

  const handleSearch = (event) => {
    event.preventDefault();
    setUserNotExist("");
    setBillingNotExist("");
    setBillingDetails(null);
    setUserData(null);
    const { email, accountNumber, userId } = formData;
    const fetchUserAndBilling = (userPromise) => {
      setIsLoading(true);
      userPromise
        .then((res) => {
          if (!!res) {
            setUserData(res);
            dispatch(PushUserGuidSearchByAdmin(res?.userGuid));
            return getOrderDataByUserIdConnect(res?.userGuid);
          } else {
            setUserNotExist("User does not exist");
            setIsLoading(false);
            return Promise.reject("User does not exist");
          }
        })
        .then((transactionRes) => {
          setTransactionDetail(transactionRes);
          if (!!transactionRes) {
            let skuGuid = transactionRes.skuId;
            setSkuId(skuGuid);
            return fetchBillingDetails(
              skuGuid,
              transactionRes.transactionDetailId,
            );
          }
        })
        .then((billingRes) => {
          if (!!billingRes) {
            setBillingDetails(billingRes);
          } else {
            setBillingNotExist("No Payment Detail Found !!");
          }
        })
        .catch((err) => {
          console.log({ err });
        })
        .finally(() => {
          setIsLoading(false);
        });
    };

    if (email || accountNumber || userId) {
      const params = {
        email: email,
        username: email,
        accountNumber: accountNumber,
        userId: userId,
      };
      fetchUserAndBilling(searchUserConnect(params));
    }
  };

  const fetchBillingDetails = (skuGuid, transId) => {
    if (transId) {
      const data = {
        skuGuid: skuGuid,
        transId: transId,
        locale: "en",
      };
      return GetBillingConnect(data);
    }
    return Promise.resolve(); // Return a resolved promise if there's no transId
  };
  const PLAN_DESCRIPTION = billingDetails?.planDescription;
  const RECURRING_PRICE = billingDetails?.recurringPrice;

  // Replace XXXX in PLAN_DESCRIPTION with the value of RECURRING_PRICE
  const updatedPlanDescription = PLAN_DESCRIPTION?.replaceAll(
    "XXXX",
    `${RECURRING_PRICE}`,
  );
  const NEXT_BILLING_DATE = moment(billingDetails?.nextBillingDate).format(
    "MMMM DD, YYYY",
  );
  const PURCHASE_DATE = moment(billingDetails?.purchaseDate).format(
    "MMMM DD, YYYY",
  );

  const dropdownRef = useRef(null);
  const handleToggle = () => {
    setIsOpen(!isOpen);
  };
  const handleToggleSearch = () => setIsSearchOpen(!isSearchOpen);
  const handleSelect = (option) => {
    setSelectedCancelReason(option.label); // Update input with the selected value
    setIsSearchOpen(false); // Close the dropdown
    setCancelResonError(false);
    setIsOpen(false);
  };

  const handleSelectSearch = (option) => {
    setSearchType(option.value);
    setIsSearchOpen(false);
  };
  // Close dropdown on clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const handleAccountCancellation = () => {
    const data = {
      isEndOfTerm: true,
      comment: selectedCancelReason,
      userGuid: userData.userGuid,
    };
    setIsLoading(true);
    AccountCancellationConnect(data)
      .then((res) => {
        if (res.data) {
          setIsOpenCancellation(false);
          toast.success("Account Cancellation Successfully!");
          return fetchBillingDetails(
            skuId,
            transactionDetails?.transactionDetailId,
          ).then((billingRes) => {
            if (!!billingRes) {
              setBillingDetails(billingRes);
            } else {
              setBillingNotExist("No Payment Detail Found !!");
            }
          });
          // signOut();
        }
      })
      .catch((err) => {
        console.log({ err });
        setIsLoading(false);
        toast.error("Account Cancellation Failed!");
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  const SEARCH_OPTION = [
    { label: "Account Number", value: "accountNumber" },
    { label: "Email", value: "email" },
    { label: "User ID", value: "userId" },
  ];

  const CANCEL_OPTIONS = [
    { label: "CHARGEBACK:Chargeback", value: "CHARGEBACK:Chargeback" },
    {
      label: "CHARGEBACK:MultipleTransaction",
      value: "CHARGEBACK:MultipleTransaction",
    },
    {
      label: "DASHBOARD:UnableToAddGuestUser",
      value: "DASHBOARD:UnableToAddGuestUser",
    },
    {
      label: "DOWNLOADDOCUMENT:DiffersWithEditor",
      value: "DOWNLOADDOCUMENT:DiffersWithEditor",
    },
    {
      label: "DOWNLOADDOCUMENT:UnableToDownload",
      value: "DOWNLOADDOCUMENT:UnableToDownload",
    },
    {
      label: "DOWNLOADDOCUMENT:BlobNotFound",
      value: "DOWNLOADDOCUMENT:BlobNotFound",
    },
    {
      label: "EDITOR:LanguageNotSupported",
      value: "EDITOR:LanguageNotSupported",
    },
    {
      label: "EDITOR:ScannedDocument",
      value: "EDITOR:ScannedDocument",
    },
    {
      label: "EMAIL:NotReceived",
      value: "EMAIL:NotReceived",
    },
    {
      label: "EMAIL:GuestUserEmailAttachment",
      value: "EMAIL:GuestUserEmailAttachment",
    },
    {
      label: "SUPPORT:CancelAccount",
      value: "SUPPORT:CancelAccount",
    },
    {
      label: "Support:RefundUser",
      value: "Support:RefundUser",
    },
    {
      label: "SUPPORT:WrongEmail",
      value: "SUPPORT:WrongEmail",
    },
    {
      label: "SUPPORT:RenewalCharges",
      value: "SUPPORT:RenewalCharges",
    },
    {
      label: "SUPPORT:CancelBecauseAlreadyCharged",
      value: "SUPPORT:CancelBecauseAlreadyCharged",
    },
    {
      label: "Operations:CancelByChargebackgurus",
      value: "Operations:CancelByChargebackgurus",
    },
    {
      label: "Portal:DuplicateUser",
      value: "Portal:DuplicateUser",
    },
    {
      label: "USER:SingleUsePurposeOnly",
      value: "USER:SingleUsePurposeOnly",
    },
    {
      label: "USER:InternetIssue",
      value: "USER:InternetIssue",
    },
    {
      label: "Other",
      value: "Other",
    },
  ];

  if (isLoading) {
    return <Loader isLoading={isLoading} />;
  }

  const handleSendRefundRequest = () => {
    sendRefundRequestConnect(userData.userGuid).then((res) => {
      if (!!res) {
        toast.success(" Refund request sent successfully.");
      }
    });
  };

  const accountCancelledAt = moment(billingDetails?.cancelledAt).format(
    "MMMM DD, YYYY",
  );
  const billingStatus = !CANCELLED_USER
    ? billingDetails?.statusInChargebee
    : `Permanent cancel will take place on ${accountCancelledAt}`;
  const paymentMethod = billingDetails?.paymentMethod || "";

  return (
    <>
      {" "}
      <div className="w-full flex justify-center items-center">
        <div className="m-10 w-full flex flex-col gap-4">
          <div className="w-full">
            <h5 className="text-2xl font-semibold"> Search For User Account</h5>
            <div
              className="w-full max-w-xs flex-col items-center container"
              ref={dropdownRef}
              onClick={handleToggleSearch} // Toggle the dropdown on click
            >
              <div className="relative w-full ">
                <input
                  id="serchType"
                  name="serchType"
                  placeholder="Search for user account"
                  value={searchType} // Show selected value
                  className="mt-1 px-3 py-[10px] block w-full border border-insightful-light-gray rounded-md shadow-sm focus:outline-none sm:text-sm cursor-pointer"
                  readOnly // Input should be read-only so it behaves like a dropdown
                />
                {/* Arrow Icon */}
                <span className="absolute right-3 top-[1.5rem] transform -translate-y-1/2 cursor-pointer">
                  <img src={ArrowIcon} alt="Arrow Icon" className="w-4 h-4" />
                </span>
              </div>
              {isSearchOpen && (
                <div className="absolute flex flex-grow mt-1 rounded-lg bg-white shadow-lg z-10 shadow-insightful-light-gray max-w-xs md:w-[400px] lg:max-w-[320px]">
                  <ul className="w-full max-w-full rounded-lg sticky py-1 text-base ring-1 ring-black ring-opacity-5 overflow-none focus:outline-none sm:text-sm overflow-scroll">
                    {SEARCH_OPTION.map((option) => (
                      <li
                        key={option.value}
                        className="text-gray-900 cursor-default select-none py-[10px] px-[20px] hover:bg-insightful-lightest-gray hover:text-black"
                        onClick={() => handleSelectSearch(option)} // Handle the selection
                      >
                        {option.label}
                      </li>
                    ))}
                  </ul>
                </div>
              )}
            </div>
            <div className="flex justify-center mt-4 w-full max-w-xs">
              <form
                className="space-y-4 w-full max-w-xs"
                onSubmit={handleSearch}
              >
                {searchType === "email" && (
                  <AppTextField
                    name="email"
                    onChange={handleInputChange}
                    value={formData.email}
                    placeholder="Enter email"
                    // readOnly={emailAddress ? true : false}
                  />
                )}
                {searchType === "accountNumber" && (
                  <AppTextField
                    name="accountNumber"
                    onChange={handleInputChange}
                    value={formData.accountNumber}
                    placeholder="Enter Account Number"
                  />
                )}
                {searchType === "userId" && (
                  <AppTextField
                    name="userId"
                    onChange={handleInputChange}
                    value={formData.userId}
                    placeholder="Enter User ID"
                  />
                )}

                <AppButton
                  type="submit"
                  className="bg-[#FE6634] hover:bg-orange-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-orange-500 text-white"
                >
                  Search
                </AppButton>
              </form>
            </div>
          </div>
          {userNotExist && (
            <p className="text-red-500 text-xl">{userNotExist}</p>
          )}
          {billingNotExist && (
            <p className="text-red-500 text-xl">{billingNotExist}</p>
          )}
          {userData && (
            <>
              <div>
                <h5 className="text-2xl font-semibold"> User Details :</h5>
                <div className="p-4 bg-white rounded-md shadow-md">
                  <div className="grid grid-cols-1 lg:grid-cols-1 gap-2">
                    {/* User Name */}
                    <div className="lg:flex-row flex flex-col">
                      <p className="font-medium w-full lg:w-1/6">User Name </p>
                      <p className="w-2/3">{userData.userName}</p>
                    </div>
                    <div className="lg:flex-row flex flex-col">
                      <p className="font-medium w-full lg:w-1/6">User Id </p>
                      <p className="w-2/3">{userData.userGuid}</p>
                    </div>

                    {/* Account Number */}
                    <div className="lg:flex-row flex flex-col">
                      <p className="font-medium w-full lg:w-1/6">
                        Account Number{" "}
                      </p>
                      <p className="w-2/3">{userData.accountNumber}</p>
                    </div>

                    {/* Is Premium */}
                    <div className="lg:flex-row flex flex-col">
                      <p className="font-medium w-full lg:w-1/6">Is Premium </p>
                      <p className="w-2/3">
                        {userData.isPremium ? "Yes" : "No"}
                      </p>
                    </div>

                    {/* Gender */}
                    <div className="lg:flex-row flex flex-col">
                      <p className="font-medium w-full lg:w-1/6">Gender </p>
                      <p className="w-2/3">{userData.gender}</p>
                    </div>
                    <div className="lg:flex-row flex flex-col">
                      <p className="font-medium w-full lg:w-1/6">
                        Account Created{" "}
                      </p>
                      <p className="w-2/3">
                        {moment(userData?.creationDate).format("MMMM DD, YYYY")}
                      </p>
                    </div>

                    {billingDetails?.orderStatus === "CANCEL" && (
                      <div className="lg:flex-row flex flex-col ">
                        <p className="font-medium w-full lg:w-1/6">
                          Subscription Status{" "}
                        </p>
                        <p className="w-2/3">
                          {billingDetails?.statusInChargebee} in {paymentMethod}
                          , Inactive in Database
                        </p>
                      </div>
                    )}
                    {billingDetails?.orderStatus === "SUCCESS" && (
                      <div className="lg:flex-row flex flex-col ">
                        <p className="font-medium w-full lg:w-1/6">
                          Subscription Status{" "}
                        </p>
                        <p className="w-2/3">
                          {billingStatus} in {paymentMethod},{" "}
                          {billingDetails?.orderStatus === "SUCCESS"
                            ? "Active in Database"
                            : "Inactive in Database"}
                        </p>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </>
          )}
          {billingDetails && (
            <div>
              <h2 className="text-xl font-bold mt-8 mb-4">Subscription</h2>
              <div className="p-4 bg-white rounded-md shadow-md flex gap-8 flex-col lg:flex-row ">
                <ul className="list-disc pl-4">
                  <li>{updatedPlanDescription}</li>
                  <li>{billingDetails?.skuGuid}</li>
                  <li>{PURCHASE_DATE}</li>
                </ul>
                <div className="flex flex-col gap-3">
                  <div className="flex justify-between items-center gap-2">
                    {billingDetails?.orderStatus === "SUCCESS" &&
                      !CANCELLED_USER && (
                        <button
                          class="text-red-500 bg-white  outline-double font-bold py-2 px-2 rounded"
                          onClick={() => {
                            if (!selectedCancelReason) {
                              return setCancelResonError(true);
                            }
                            setIsOpenCancellation(true);
                          }}
                        >
                          Cancel Subscription
                        </button>
                      )}

                    <button
                      class="text-blue-500 bg-white  outline-double font-bold py-2 px-2 rounded"
                      onClick={handleSendRefundRequest}
                    >
                      Send Refund Request
                    </button>
                  </div>
                  {billingDetails?.orderStatus === "SUCCESS" &&
                    !CANCELLED_USER && (
                      <div>
                        <div
                          className="max-w-full w-[421.2px] flex-col items-center container"
                          ref={dropdownRef}
                        >
                          <label
                            htmlFor="cancelReason"
                            className="block text-sm font-medium text-gray-700 mb-1"
                          >
                            Cancellation Reason
                          </label>
                          <div className="relative w-full">
                            <input
                              id="cancelReason"
                              name="cancelReason"
                              value={selectedCancelReason} // Show selected value
                              className="mt-1 block w-full bg-[#f8f8f8] rounded-lg border-insightful-gray border-1 p-2 shadow-sm focus:border-insightful-purple focus:ring focus:ring-insightful-purple focus:ring-opacity-50"
                              onClick={handleToggle} // Toggle the dropdown on click
                              readOnly // Input should be read-only so it behaves like a dropdown
                            />
                            <span className="absolute right-3 top-1/2 transform -translate-y-1/2">
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                className="h-4 w-4 text-gray-500"
                                fill="none"
                                viewBox="0 0 24 24"
                                stroke="currentColor"
                              >
                                <path
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                  strokeWidth={2}
                                  d="M7 10l5 5 5-5"
                                />
                              </svg>
                            </span>
                          </div>

                          {cancelReasonError && (
                            <p className="text-red-500 mt-1">
                              Cancellation Reason is required
                            </p>
                          )}

                          {isOpen && (
                            <div className="absolute flex flex-grow mt-1 rounded-lg bg-white shadow-lg shadow-insightful-light-gray w-[323px] max-w-[362px] md:w-[421px] lg:max-w-[421.2px]">
                              <ul className=" w-full max-w-full rounded-lg sticky py-1 text-base ring-1 ring-black ring-opacity-5 overflow-none focus:outline-none sm:text-sm h-40 overflow-scroll">
                                {CANCEL_OPTIONS.map((option) => (
                                  <li
                                    key={option.value}
                                    className="text-gray-900 cursor-default select-none py-[10px] px-[20px] hover:bg-insightful-lightest-gray hover:text-black"
                                    onClick={() => handleSelect(option)} // Handle the selection
                                  >
                                    {option.label}
                                  </li>
                                ))}
                              </ul>
                            </div>
                          )}
                        </div>
                      </div>
                    )}
                  {billingDetails?.orderStatus === "SUCCESS" &&
                    !CANCELLED_USER && (
                      <div>
                        <p>
                          {" "}
                          <span className="font-bold">
                            Next Billing Date
                          </span>: {NEXT_BILLING_DATE}
                        </p>
                      </div>
                    )}
                </div>
              </div>

              <h2 className="text-xl font-bold mt-8 mb-4">Payment Method</h2>
              <p>
                {billingDetails?.paymentMethod
                  ? billingDetails.paymentMethod
                  : "----"}
              </p>
            </div>
          )}

          <CancelPlanPopup
            isOpen={isOpenCancellation}
            setIsOpen={setIsOpenCancellation}
            onConfirm={handleAccountCancellation}
          />
        </div>
      </div>{" "}
    </>
  );
}

export default AdminUserDetails;
